import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "id",
      key: "id",
      title: "ID Jabatan",
    },
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Jabatan",
      render: (text) => (
        <div
          style={{
            textTransform: "capitalize",
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "total_employee",
      key: "total_employee",
      title: "Jumlah Pegawai",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Deskripsi Pekerjaan",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="col-1 d-flex justify-content-center flex-row">
          <div className="mr-2">
            <CanAccess
              role={AuthorizationList.update_jabatan}
              yes={
                <BiEditAlt
                  onClick={() => handleEdit(record)}
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              }
            />
          </div>

          <CanAccess
            role={AuthorizationList.delete_jabatan}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
